export default __webpack_public_path__ + "static/media/centifica-bl.2edf4240.png";